'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    getSupportedTransformProperty = require('../utils/getSupportedTransformProperty'),
    Easings = require('../constants/Easings'),
    { PropTypes, Children } = React;

require('./Rotator.less');

var DELAY = 400;

var Rotator = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    activeIndex: PropTypes.number.isRequired
  },

  getChildStyle(index) {
    var transformProperty = getSupportedTransformProperty(),
        relativeIndex = index - this.props.activeIndex,
        transform = `translate3d(0, ${relativeIndex * 150}%, 0)`;

    return {
      [`${transformProperty.js}`]: transform,
      opacity: index === this.props.activeIndex ? 1 : 0,
      transition: `
        ${transformProperty.css} ${DELAY}ms ${Easings.BEZIER},
        opacity ${DELAY}ms ${Easings.BEZIER}
      `
    };
  },

  render() {
    return (
      <div className={this.getClassName()}>
        {Children.map(this.props.children, this.wrapChild)}
      </div>
    );
  },

  wrapChild(child, index) {
    if (!child) {
      return;
    }

    return (
      <div className='Rotator-child'
           style={this.getChildStyle(index)}>
        {child}
      </div>
    );
  }
});

module.exports = Rotator;



/** WEBPACK FOOTER **
 ** ./molecules/Rotator.jsx
 **/